import * as io from 'io-ts';

export const deprecatedType = new io.Type<undefined, undefined, unknown>(
    'DeprecatedProperty',
    (u): u is undefined => u === undefined,
    (u, c) => {
        const propertyName = c[c.length - 1].key;

        return u === undefined ? io.success(undefined) : io.failure(u, c, `Property "${propertyName}" is deprecated and should not be used`);
    },
    io.identity,
);
